import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { filterBySourceSkuClassId } from '../../../../../../Calculations/calculationsSlice';
import RedistributionGenericMultiSelectorFilter from './RedistributionGenericMultiSelectorFilter';
import { useTemplateOrCalculation } from '../../../../../../../hooks/useTemplateOrCalculation';
import { useGetStatsSkuClassesQuery } from '../../../../../Statistics/apiCalculationStatistics';

const SourceSkuClassFilter: React.FC = () => {
  const calculationId = useTemplateOrCalculation().id;
  const { data, isFetching, isError } = useGetStatsSkuClassesQuery({ calculationId });

  const redistributionFilterSourceSkuClassIds = useSelector(
    state => state.calculations.redistributionFilterSourceSkuClassIds,
  );

  const selectorOptions = useMemo(() => {
    if (!data) {
      return [];
    }
    return data
      .filter(item => item.quantitySource > 0)
      .map(item => ({ id: item.skuClass.id, label: item.skuClass.name }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [data]);

  if (isError) {
    return null;
  }

  return (
    <RedistributionGenericMultiSelectorFilter
      label="Source Sku Class"
      options={selectorOptions}
      value={redistributionFilterSourceSkuClassIds}
      dispatcher={filterBySourceSkuClassId}
      loading={isFetching}
    />
  );
};

export default SourceSkuClassFilter;
